"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSortUrls = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _url = require("../utils/url");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Utils

/*
 * Generate a memoized list of page size urls. Chaning the page size will reset
 * the offset to zero to simplify things.
 */
const useSortUrls = ({
  options = []
}) => {
  const location = (0, _reactRouterDom.useLocation)();
  return (0, _react.useMemo)(() => (0, _url.buildUrlSet)(`${location.pathname}${location.search}`, 'sort', options.map(({
    id
  }) => id), {
    offset: 0
  }), [location.pathname, location.search, options]);
};
exports.useSortUrls = useSortUrls;